// extracted by mini-css-extract-plugin
export default {"buscador":"Buscador_buscador__ozkBI"};